/**
 * Centralized typed query keys for TanStack Query.
 * All paginated/list queries should compose keys from here.
 */
export type ListParams = {
  page: number;
  pageSize: number;
  search?: string;
  filters?: Record<string, unknown>;
  orderBy?: string;
  ascending?: boolean;
};

export const queryKeys = {
  all: ["app"] as const,

  questions: {
    all: ["questions"] as const,
    list: (params: ListParams) => ["questions", "list", params] as const,
    detail: (id: string) => ["questions", "detail", id] as const,
  },
  instructorTests: {
    all: ["instructorTests"] as const,
    list: (params: ListParams) => ["instructorTests", "list", params] as const,
    detail: (id: string) => ["instructorTests", "detail", id] as const,
  },
  studentLists: {
    all: ["studentLists"] as const,
    list: (params: ListParams) => ["studentLists", "list", params] as const,
  },
  tutoringSchedules: {
    all: ["tutoringSchedules"] as const,
    list: (params: ListParams) => ["tutoringSchedules", "list", params] as const,
  },
  subjects: {
    all: ["subjects"] as const,
    list: (params: ListParams) => ["subjects", "list", params] as const,
  },
  categorySuggestions: {
    list: (params: ListParams) => ["categorySuggestions", "list", params] as const,
  },
  reportedQuestions: {
    list: (params: ListParams) => ["reportedQuestions", "list", params] as const,
  },
  aiLogs: {
    list: (params: ListParams) => ["aiLogs", "list", params] as const,
  },
  emailCampaigns: {
    list: (params: ListParams) => ["emailCampaigns", "list", params] as const,
  },
  emailTemplates: {
    list: (params: ListParams) => ["emailTemplates", "list", params] as const,
  },
  testSessions: {
    list: (params: ListParams) => ["testSessions", "list", params] as const,
  },
  calendarEvents: {
    list: (params: ListParams) => ["calendarEvents", "list", params] as const,
  },
} as const;
